import React from "react";
import ReactDOM from "react-dom";
import { AppContainer } from "react-hot-loader";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { SolutionProvider } from "./SolutionsApp/contexts";
import { App } from "./SolutionsApp/index";
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            staleTime: 0,
            networkMode: "always",
        },
    },
});
if (document.getElementById("app-solutions")) {
    ReactDOM.render(React.createElement(AppContainer, null,
        React.createElement(QueryClientProvider, { client: queryClient },
            React.createElement(SolutionProvider, null,
                React.createElement(App, null)))), document.getElementById("app-solutions"));
}
